const DAYS_PER_WEEK = 7;
const HOURS_PER_DAY = 24;
const LOCALE = 'en-US';
const MINUTES_PER_HOUR = 60;
const MONTHS_PER_YEAR = 12;
const SECONDS_PER_MINUTE = 60;
const WEEKS_PER_MONTH = 4;

// Pluralizes a unit of time (e.g. "1 minute ago", "2 minute(s) ago").
const pluralizeTime = (count, timeUnit) => {
  return count === 1 ? `${count} ${timeUnit} ago` : `${count} ${timeUnit}s ago`;
};

// Returns a relative time (e.g. "5 minutes ago").
export const formatRelativeTime = (dateStr) => {
  const date = new Date(dateStr);
  const now = new Date();

  const secondsAgo = Math.floor((now - date) / 1000);
  if (secondsAgo < SECONDS_PER_MINUTE) return 'A few seconds ago';

  const minutesAgo = Math.floor(secondsAgo / SECONDS_PER_MINUTE);
  if (minutesAgo < MINUTES_PER_HOUR) return pluralizeTime(minutesAgo, 'minute');

  const hoursAgo = Math.floor(minutesAgo / MINUTES_PER_HOUR);
  if (hoursAgo < HOURS_PER_DAY) return pluralizeTime(hoursAgo, 'hour');

  const yesterday = new Date(now);
  yesterday.setDate(yesterday.getDate() - 1);
  if (date.toDateString() === yesterday.toDateString()) return 'Yesterday';

  const daysAgo = Math.floor(hoursAgo / HOURS_PER_DAY);
  if (daysAgo < DAYS_PER_WEEK) return pluralizeTime(daysAgo, 'day');

  const weeksAgo = Math.floor(daysAgo / DAYS_PER_WEEK);
  if (weeksAgo < WEEKS_PER_MONTH) return pluralizeTime(weeksAgo, 'week');

  const monthsAgo = Math.floor(weeksAgo / WEEKS_PER_MONTH);
  if (monthsAgo < MONTHS_PER_YEAR) return pluralizeTime(monthsAgo, 'month');

  const yearsAgo = Math.floor(monthsAgo / MONTHS_PER_YEAR);
  return pluralizeTime(yearsAgo, 'year');
};

// Returns a readable datetime (e.g. "Oct 22, 2023, 9:00 AM").
export const formatDateTime = (dateStr) => {
  const date = new Date(dateStr);

  return date.toLocaleDateString(LOCALE, {
    day: 'numeric',
    hour: 'numeric',
    hour12: true,
    minute: '2-digit',
    month: 'short',
    year: 'numeric',
  });
};
